

export const TEST_BINGO_CARD_ARRAY = Array(25).fill(null).map((a, aI) => aI % 4 === 0 ? 5 : null)


export const CHIP_VALUE_ARR = [1,2,3,4,5,10]